import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ContextApi from './App/ApiContext';
import ContextCore from './App/CoreContext';
import MainView from './App/MainView';
import { useEffect } from 'react';

const loadCss = async url => {
  return new Promise((rs, rj) => {
    const style = document.createElement('link');
    style.rel = "stylesheet";
    style.href = url;
    style.async = true;
    style.onload = rs;
    style.onerror = rj;
    document.body.appendChild(style);
  })
};
function App() {
  useEffect(() => {
    (async () => {
      const { host } = window.location;
      const folder = host.split(':')[0];
      await loadCss(`/cfg/${folder}/style.css`);
    })();

  }, []);
  return (
    <ContextApi>
      <ContextCore>
        <BrowserRouter>
          <Routes>
            <Route index element={<MainView />} />
            <Route path="/:store_code?" element={<MainView />} />
          </Routes>
        </BrowserRouter>
      </ContextCore>
    </ContextApi>
  );
}
export default App;
